import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    AddResourceInstances, EditResourceInstances, ResourceInstances,
    ResourceInstancesParams,
    ResourceInstancesWithPage,
} from '@app/interfaces/rm/resource-instances';
import { SelectOption } from '@app/interfaces/sys/dict';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ResourceInstancesService {
    private baseUrl = environment.api.services.rm + '/resource-instances';

    constructor(private http: HttpClient) {
    }

    async find(params?: ResourceInstancesParams): Promise<ResourceInstancesWithPage> {
        return lastValueFrom(this.http.get<ResourceInstancesWithPage>(`${this.baseUrl}`, {
            params: params ? Object.assign(params) : {},
        }));
    }

    async options(params?: ResourceInstancesParams): Promise<SelectOption[]> {
        return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`, {
            params: params ? Object.assign(params) : {},
        }));
    }

    async add(params: AddResourceInstances): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, params));
    }

    async edit(data: EditResourceInstances): Promise<ResourceInstances> {
        return lastValueFrom(this.http.put<ResourceInstances>(`${this.baseUrl}`, data));
    }

    async delete(id: number): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }))
    }

    async findAllOptions(): Promise<SelectOption[]> {
        return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`));
    }

    async one(id: number): Promise<ResourceInstances> {
        return lastValueFrom(this.http.get<ResourceInstances>(`${this.baseUrl}/one`, {
            params: Object.assign({ id }),
        }));
    }

    getCategoryList(): SelectOption[] {
        return [
            {
                label: 'Accessory',
                value: 'ACCESSORY',
            },
            {
                label: 'Physical',
                value: 'PHYSICAL',
            },
            {
                label: 'Software',
                value: 'SOFTWARE',
            },
        ];
    }
}